// src/pages/auth/SignupStep1.jsx
import React, { useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import AuthLayout from "../../components/AuthLayout";
import API_BASE_URL from "../../config/api";

export default function SignupStep1() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleNext = async (e) => {
    e.preventDefault();
    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      toast.error("Please enter a valid email address");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/users/send-signup-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success("OTP sent to your email!");
        sessionStorage.setItem("signupEmail", email);
        navigate("/verify-otp");
      } else {
        toast.error(data.message || "Failed to send OTP");
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      toast.error("Failed to send OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <Box
        component="form"
        onSubmit={handleNext}
        sx={{ display: "flex", flexDirection: "column", gap: 2 }}
      >
        {/* <Typography variant="h5" textAlign="center" fontWeight={600}> */}
        <Typography
                  textAlign="center"
                  fontWeight={600}
                  color="white"
                  sx={{
                    fontSize: {
                      xs: '1.12rem', // small screens (phones)
                      sm: '1.5rem',  // tablets
                      md: '1.75rem', // laptops
                      lg: '2rem',    // desktops
                    },
                    
                  }}
          >
          Create your Account
        </Typography>
        {/* <Typography variant="body2" textAlign="center">
          Enter your email to get a verification code.
        </Typography> */}

        <TextField
          label="Email Address"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          fullWidth
        />

        <Button variant="contained" type="submit" size="large" disabled={loading}>
          {loading ? "Sending..." : "Send OTP"}
        </Button>
      </Box>
    </AuthLayout>
  );
}
